import { ImageFieldClass } from './ImageField.component'

export const ImageField = ImageFieldClass
